module.exports = __webpack_public_path__ + "img/visiosign_cloud_logo_white.9ec7e867.svg";